"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _ArrowDropDown = _interopRequireDefault(require("@material-ui/icons/ArrowDropDown"));

var _DropDownMenuModule = _interopRequireDefault(require("./DropDownMenu.module.scss"));

var _customProps = require("../../../../utils/customProps");

var DropDownMenu = function DropDownMenu(_ref) {
  var children = _ref.children,
      btnTxt = _ref.btnTxt,
      color = _ref.color,
      variant = _ref.variant,
      size = _ref.size,
      rootClass = _ref.rootClass;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _DropDownMenuModule.default.dropdown
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: rootClass,
    color: color,
    variant: variant,
    size: size,
    endIcon: /*#__PURE__*/_react.default.createElement(_ArrowDropDown.default, null)
  }, btnTxt), /*#__PURE__*/_react.default.createElement(_Paper.default, {
    variant: "outlined",
    className: _DropDownMenuModule.default.dropdownContent
  }, children));
};

var _default = DropDownMenu;
exports.default = _default;
DropDownMenu.propTypes = {
  /** button text for dropdown click */
  btnTxt: _propTypes.default.string,

  /** mui prop: 'default', 'inherit', 'primary', 'secondary' */
  color: function color(props, propName, componentName) {
    var validProps = ['default', 'inherit', 'primary', 'secondary'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /** mui prop: 'text' ,'outlined', 'contained' */
  variant: function variant(props, propName, componentName) {
    var validProps = ['text', 'outlined', 'contained'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /** mui prop: 'small', 'medium', 'large' */
  size: function size(props, propName, componentName) {
    var validProps = ['small', 'medium', 'large'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /** stroyblok multiselect of css classes */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),
  children: _propTypes.default.node.isRequired
};
DropDownMenu.defaultProps = {
  rootClass: '',
  variant: 'text',
  btnTxt: '',
  color: 'secondary',
  size: 'medium'
};